import { render, staticRenderFns } from "./oneTimeLinkExpired.vue?vue&type=template&id=2a64440e&scoped=true"
import script from "./oneTimeLinkExpired.vue?vue&type=script&lang=js"
export * from "./oneTimeLinkExpired.vue?vue&type=script&lang=js"
import style0 from "./oneTimeLinkExpired.vue?vue&type=style&index=0&id=2a64440e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a64440e",
  null
  
)

export default component.exports